<template>
  <div>
    <div class="pb-14">
      <LoadingView
        :loading="isLoading || isFetching"
        :error="error"
        class="min-h-[70vh]"
      >
        <div class="relative overflow-hidden">
          <div class="container px-0">
            <CenteredSlider :slides="data?.media" />
          </div>
          <div class="absolute inset-0 size-full pointer-events-none z-20">
            <div
              class="absolute inset-x-0 bottom-0 bg-gradient-to-t via-black/50 from-black/90 h-1/2 to-transparent"
            />
            <div
              class="container h-full relative flex flex-col items-start justify-between py-6"
            >
              <div class="flex gap-4 items-start justify-between w-full">
                <div class="flex gap-3">
                  <UIBadge
                    v-if="data.type?.title"
                    size="base"
                    :title="data.type?.title"
                  />
                  <UIBadge
                    v-if="data.meta?.age_restricted"
                    size="base"
                    :title="`${data.meta?.age_restricted}+`"
                  />
                </div>
                <div>
                  <UISubscribe
                    class="ring-1 ring-white/50 pointer-events-auto"
                    :subscribed="data.subscribed"
                    @click="subscribe"
                  />
                </div>
              </div>
              <UIHeading :title="data.title" tag="1" class="mb-3 text-white" />
            </div>
          </div>
        </div>
        <div class="container py-14">
          <div class="flex flex-wrap -mx-4">
            <div class="w-full lg:w-8/12 px-4 mb-4 md:mb-0">
              <LoadingView :loading="isLoading">
                <div class="space-y-8">
                  <section class="w-full">
                    <a
                      href="https://www.culture.ru/pushkinskaya-karta"
                      target="_blank"
                      v-if="
                        data?.meta &&
                        data?.meta?.specials &&
                        data?.meta?.specials.includes('is_pushkin_card')
                      "
                      class="flex items-center"
                    >
                      <IconPushkin
                        class="size-20 p-2 rounded-full mr-6 bg-primary-50 dark:bg-white/20"
                      />
                      <div class="flex flex-col">
                        <UIHeading
                          title="Доступен по Пушкинской карте"
                          tag="6"
                          class="mb-2"
                        />
                        <p class="text-sm dark:text-white/70 text-black/70">
                          Программа популяризации культурных мероприятий среди
                          молодежи
                        </p>
                      </div>
                    </a>
                  </section>
                  <section v-if="data.requires_registration">
                    <UIHeading
                      class="mb-3"
                      title="Регистрация"
                      tag="2"
                      styles="3"
                    />

                    <div
                      v-if="data.requires_registration"
                      class="flex flex-col md:flex-row gap-4"
                    >
                      <div class="relative flex-1">
                        <p v-if="!data.ticket_id" class="max-w-[70%]">
                          Для того чтобы принять участие в мероприятии Вам
                          необходимо получить билет
                        </p>
                        <p v-else class="max-w-[70%]">
                          Вы уже участник мероприятия
                        </p>
                        <IconHandFingerRight
                          class="hidden md:block absolute size-10 text-gray-300 dark:text-gray-600 right-0 top-0"
                        />
                      </div>
                      <div>
                        <UIButton
                          v-if="data.requires_registration && !data.ticket_id"
                          class="whitespace-nowrap"
                          size="lg"
                          :icon="IconTicket"
                          :disabled="!ticketsAvailable"
                          :title="
                            ticketsAvailable
                              ? `Получить билет`
                              : `Билеты закончились`
                          "
                          @click="obtainTicket"
                        />
                        <UIButton
                          v-if="data.ticket_id"
                          class="whitespace-nowrap"
                          size="lg"
                          :icon="IconTicket"
                          :is-loading="isLoadingQr"
                          :loading-icon="LoadingIcon"
                          title="Открыть билет"
                          @click="openTicketModal"
                        />
                      </div>
                    </div>
                  </section>
                  <section>
                    <Venues
                      :url="data.meta.url"
                      :resources="venuesData.resources"
                      :slots="venuesData.slots"
                    />
                  </section>
                  <section>
                    <UIHeading title="О мероприятии" tag="2" styles="3" />

                    <div
                      v-html="data.description"
                      class="!my-4 overflow-hidden"
                      :class="proseContent"
                    />
                  </section>
                  <section>
                    <div class="grid md:grid-cols-3 gap-3">
                      <div
                        v-for="(item, i) in meta.filter(
                          (it) => it.value !== null,
                        )"
                        :key="i"
                      >
                        <div class="text-black/60 dark:text-white/60">
                          {{ item.title }}
                        </div>
                        <div>{{ item.value }}</div>
                      </div>
                    </div>
                  </section>
                  <section
                    v-if="
                      data?.meta &&
                      data?.meta?.specifications &&
                      data?.meta?.specifications.length
                    "
                  >
                    <div class="text-black/60 dark:text-white/60 mb-1">
                      Соблюдение требований безопасности
                    </div>
                    <div class="flex flex-wrap gap-4">
                      <div
                        v-for="(item, i) in secure.filter((item) =>
                          data.meta.specifications.includes(item.id),
                        )"
                        :key="i"
                      >
                        <component
                          v-tippy="{ content: item.text }"
                          class="size-7"
                          :is="item.icon"
                        />
                      </div>
                    </div>
                  </section>
                  <section
                    v-if="
                      data?.meta &&
                      data?.meta?.specifications &&
                      data?.meta?.specifications.includes('meals') &&
                      data?.meta?.meals_info
                    "
                  >
                    <div class="text-black/60 dark:text-white/60 mb-1">
                      Питание
                    </div>
                    <p>{{ data.meta.meals_info }}</p>
                  </section>
                  <section
                    v-if="
                      data?.meta &&
                      data?.meta?.specials &&
                      data?.meta?.specials.includes('interactive') &&
                      data?.meta?.interactive_info
                    "
                  >
                    <div class="text-black/60 dark:text-white/60 mb-1">
                      Итерактив
                    </div>
                    <p>{{ data.meta.interactive_info }}</p>
                  </section>
                </div>

                <div class="flex justify-between mt-6">
                  <div v-if="data?.source?.link">
                    <div
                      class="text-xs text-black-600 dark:text-black-300 tracking-widest uppercase mb-1"
                      v-text="'Источник'"
                    />
                    <a
                      class="text-primary dark:text-brand-1"
                      :href="data.source?.link || data?.external_url"
                      target="_blank"
                      v-text="data.source?.title || data?.external_url"
                    />
                  </div>
                  <div v-if="data">
                    <div>
                      <div
                        class="text-xs text-black-600 dark:text-black-300 tracking-widest uppercase mb-2"
                        v-text="'Поделиться'"
                      />

                      <ShareButtons :data="socialNetworkShareData" />
                    </div>
                  </div>
                </div>
              </LoadingView>
            </div>
            <div class="w-full lg:w-8/12 px-4">
              <Comments
                class="mt-12"
                :id="route.params.id"
                :dependant="!isLoading"
                root="events"
                :endpoint="`/events/${route.params.id}/comments`"
              />
            </div>
          </div>
        </div>
      </LoadingView>
    </div>
    <UIFooter />
  </div>
</template>

<script setup>
import { notify } from 'notiwind'
import { computed, ref } from 'vue'
import { useQuery } from 'vue-query'
import { onBeforeRouteUpdate } from 'vue-router'

import {
  IconAmbulance,
  IconAntennaBars5,
  IconBabyCarriage,
  IconBadgeWc,
  IconCalendarClock,
  IconCreditCard,
  IconDisabled,
  IconHandFingerRight,
  IconMapPin,
  IconShieldHalfFilled,
  IconTicket,
  IconToolsKitchen2,
} from '@tabler/icons-vue'

import Comments from '@/components/comments/Comments.vue'
import ConditionalDisplaying from '@/components/common/ConditionalDisplaying.vue'
import Venues from '@/components/events/Venues.vue'
import IconPushkin from '@/components/IconPushkin.vue'
import LoadingIcon from '@/components/loading/LoadingIcon.vue'
import LoadingView from '@/components/loading/LoadingView.vue'
import QrModal from '@/components/modals/QrModal.vue'
import ShareButtons from '@/components/share/ShareButtons.vue'
import CenteredSlider from '@/components/ui/CenteredSlider.vue'
import UIBadge from '@/components/ui/UIBadge.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UIFooter from '@/components/ui/UIFooter.vue'
import UIHeading from '@/components/ui/UIHeading.vue'
import UISubscribe from '@/components/ui/UISubscribe.vue'
import useConfirm from '@/plugins/confirm.js'
import useModalDynamic from '@/plugins/useModalDynamic.js'
import {
  callExternalModal,
  callMapModal,
  createTippyAuth,
  plural,
} from '@/utils/global.js'
import { getMediaPath } from '@/utils/media.js'
import { useReactions } from '@/utils/reactions.js'
import { cardAside, proseContent } from '@/utils/ui.js'
import { usePageId } from '@/utils/use/usePageId.js'

const {
  route,
  http,
  client,
  auth,
  global,
  pageState: { isLoading, isFetching, isError, data, error, refetch },
  subscribe,
} = usePageId({
  rootKey: 'events',
  queryKey: 'afisha',
})

const isLoadingQr = ref(false)
const { setReaction } = useReactions({
  queryClient: client,
  auth,
  queryKey: ['afisha', route.params.id],
  rootKey: 'events',
  rootParamId: route.params.id,
})
const secure = ref([
  {
    id: 'police',
    text: 'Дежурство полиции',
    icon: IconShieldHalfFilled,
  },
  {
    id: 'ambulance',
    text: 'Дежурство скорой помощи',
    icon: IconAmbulance,
  },
  {
    id: 'inclusivity',
    text: 'Доступно для маломобильных групп населения',
    icon: IconDisabled,
  },
  {
    id: 'meals',
    text: 'Есть питание',
    icon: IconToolsKitchen2,
  },
  {
    id: 'toilets',
    text: 'Есть туалет',
    icon: IconBadgeWc,
  },
  {
    id: 'baby_room',
    text: 'Комната матери и ребенка',
    icon: IconBabyCarriage,
  },
  {
    id: 'connection',
    text: 'Наличие связи (интернет или мобильная связь)',
    icon: IconAntennaBars5,
  },
])

function formatMinutesToHoursAndMinutes(minutes) {
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60

  const hoursLabel =
    hours === 1 ? 'час' : hours >= 2 && hours <= 4 ? 'часа' : 'часов'
  const minutesLabel =
    remainingMinutes % 10 === 1 && remainingMinutes !== 11
      ? 'минута'
      : remainingMinutes % 10 >= 2 &&
          remainingMinutes % 10 <= 4 &&
          !(remainingMinutes >= 12 && remainingMinutes <= 14)
        ? 'минуты'
        : 'минут'

  return `${hours} ${hoursLabel} ${remainingMinutes} ${minutesLabel}`
}

const meta = ref([
  {
    title: 'Стоимость',
    value: computed(() =>
      data.value?.meta?.price ? `от ${data.value.meta?.price} ₽` : 'Бесплатно',
    ),
  },
  {
    title: 'Возраст',
    value: computed(() =>
      data.value?.meta?.age_restricted
        ? `${data.value?.meta?.age_restricted}+`
        : null,
    ),
  },
  {
    title: 'Продолжительность',
    value: computed(() =>
      data.value?.meta?.duration
        ? formatMinutesToHoursAndMinutes(data.value?.meta?.duration)
        : null,
    ),
  },
])

function useVenuesQuery() {
  return useQuery(['venues', route.params.id], () =>
    http(`/events/${route.params.id}/venues`).then(({ resources, slots }) => {
      return {
        resources,
        slots,
      }
    }),
  )
}

const socialNetworkShareData = computed(() => {
  const path = new URL(location.href)
  if (auth.user) {
    path.searchParams.append('referral', auth.user.referral)
  }

  return {
    title: data.value?.title,
    url: path.toString(),
    media: getMediaPath(data.value?.media, 'default-optimized'),
  }
})

const { isLoading: isLoadingVenues, data: venuesData } = useVenuesQuery()

onBeforeRouteUpdate(() => {
  refetch.value()
})

async function obtainTicket(e) {
  if (!auth.user) {
    createTippyAuth(e, 'Чтобы получить билет')
    return
  }

  const result = await useConfirm({
    caption:
      'Прежде чем продолжить, подтвердите, что вы готовы получить билет на мероприятие',
  })

  if (result) {
    http(`/events/${data.value.id}/ticket`, {
      method: 'POST',
    })
      .then(({ resource }) => {
        // data.value.has_ticket = true
        // data.value.tickets_count--
        notify({
          group: 'default',
          type: 'success',
          title: 'Билет был добавлен в ваш профиль',
        })
        refetch.value()
      })
      .catch((e) => {
        if (e.statusCode === 422) {
          notify({
            group: 'default',
            type: 'success',
            title: e.data.message,
          })
        } else {
          notify({
            group: 'default',
            type: 'error',
            title: 'Не удалось выдать билет',
            text: e.data.message,
          })
        }
      })
  }
}

async function openTicketModal() {
  isLoadingQr.value = true

  http(`/events/${data.value.id}/tickets/qr`)
    .then((qrData) => {
      useModalDynamic({
        opened: true,
        component: QrModal,
        compAttrs: {
          qr: qrData,
          id: data.value?.ticket_id,
          caption:
            'Предъявите ваш QR код для подтверждения участия в мероприятии и последующего получения баллов.',
        },
      })
    })
    .finally(() => (isLoadingQr.value = false))
}

const ticketsAvailable = computed(() => {
  return data.tickets_capacity === null
    ? true
    : data.value?.tickets_capacity - data.value?.tickets_count > 0
})
</script>
